'use client';

import { AnimatePresence } from 'framer-motion';
import { useModalSlideStore } from '@/stores/useModalSlideStore';
import ModalSlide from '@/components/modal/ModalSlide';

const MODAL_SLIDE_BASE_Z_INDEX = 2000;
const MODAL_SLIDE_Z_INDEX_STEP = 10;

export default function ModalSlideWrapper() {
    const slides = useModalSlideStore((s) => s.slides);
    const closeModalSlide = useModalSlideStore((s) => s.closeModalSlide);

    return (
        <AnimatePresence>
            {slides.map((slide, index) => (
                <ModalSlide
                    key={slide.id}
                    onClose={() => closeModalSlide(slide.id)}
                    isHeaderLogo={slide.isHeaderLog}
                    pcWidth={slide.size?.pcWidth}
                    mbWidth={slide.size?.mbWidth}
                    height={slide.size?.height}
                    direction={slide.direction}
                    zIndex={MODAL_SLIDE_BASE_Z_INDEX + index * MODAL_SLIDE_Z_INDEX_STEP}
                >
                    {slide.component}
                </ModalSlide>
            ))}
        </AnimatePresence>
    );
}
